import L from "leaflet";
import { onDocumentReady } from "@story/story_assets/utils";
import { ModalDialog } from "@story/story_assets/modal/modal_dialog";
import db from "./components/cz.json";

const API_KEY = 'S7gRUKCVB8aFoWneRj0XSeIKbGEtlF1oEwblsacjlG0';

function createMap(element) {
	let position = [49.8171606, 15.4766247];
	let zoom = 7;

	const map = L.map(element).setView(position, zoom);
	map.attributionControl.setPrefix(false);

	L.tileLayer(`https://api.mapy.cz/v1/maptiles/basic/256@2x/{z}/{x}/{y}?apikey=${API_KEY}`, {
		minZoom: 0,
		maxZoom: 19,
		attribution: '<a href="https://api.mapy.cz/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>',
	}).addTo(map);

	L.geoJSON(db, {
		style: {
			color: '#C32026',
			weight: 2
		},
		onEachFeature: (feature, layer) => {
			layer.on("click", (event) => {
				const region = feature.properties.region;
				const id = `country_${region}`;
				let url = element.getAttribute("data-url").replace("--country--", id);

				ModalDialog.openAjax(url);
			});
		}
	}).addTo(map);
};

onDocumentReady(() => {
	const element = document.getElementById("map");
	if (!element) {
		return;
	}

	createMap(element);
});






// ; (function() {

// 	let element = document.getElementById("map");
// 	let map = null;

// 	function initMap() {
// 		let mapCenter = SMap.Coords.fromWGS84(15.4766247, 49.8171606);
// 		let mapZoom = 7;

// 		map = new SMap(element, mapCenter, mapZoom);
// 		map.addDefaultLayer(SMap.DEF_BASE).enable();

// 		map.addControl(new SMap.Control.Mouse(SMap.MOUSE_PAN | SMap.MOUSE_ZOOM));
// 		map.addControl(new SMap.Control.ZoomNotification);
// 		map.addControl(new SMap.Control.Compass({ title: SMap._("map.move") }));
// 		map.addControl(new SMap.Control.Zoom(
// 			{
// 				2: SMap._("map.zooms.world"),
// 				5: SMap._("map.zooms.states"),
// 				8: SMap._("map.zooms.districts"),
// 				11: SMap._("map.zooms.cities"),
// 				14: SMap._("map.zooms.municipalities"),
// 				17: SMap._("map.zooms.streets"),
// 				20: SMap._("map.zooms.houses"),
// 				21: SMap._("map.zooms.birdEye")
// 			},
// 			{
// 				titles: [SMap._("map.zoomIn"), SMap._("map.zoomOut")]
// 			}
// 		));

// 		// map.addControl(new SMap.Control.Scale);
// 		map.addControl(new SMap.Control.Sync);

// 		// Place controls
// 		map.setPadding("right", map.getPadding("right") + 73 + 8 + 2);
// 		JAK.DOM.addClass(map._dom.container, "smap-defaults");

// 		// Set up cursor
// 		map.setCursor("move");
// 	}

// 	function initRegions() {


// 		let layer = new SMap.Layer.Geometry();
// 		map.addLayer(layer);
// 		layer.enable();

// 		for (let regionName in regions) {
// 			let points = [];
// 			let isCommand = false;
// 			for (let coordinates of regions[regionName]) {
// 				if (coordinates == "M") {
// 					if (0 < points.length) {
// 						points.push("Z");
// 					}
// 					points.push("M");
// 					isCommand = true;
// 					continue;
// 				}

// 				if (!isCommand) {
// 					points.push("L");
// 				}
// 				isCommand = false;

// 				points.push(SMap.Coords.fromWGS84(coordinates[1], coordinates[0]));
// 			}
// 			points.push("Z");

// 			let polygon = new SMap.Geometry(SMap.GEOMETRY_PATH, "map-region-" + regionName, points, {
// 				color: "#C32026",
// 				opacity: 0.3,
// 				outlineColor: "#C32026",
// 				outlineOpacity: 1,
// 				outlineWidth: 1,
// 				curvature: 0
// 			});
// 			layer.addGeometry(polygon);
// 		}
// 	}

// 	function initSignals() {
// 		map.getSignals().addListener("window", "geometry-click", function(event) {
// 			const geometry = event.target;
// 			const id = geometry.getId().replace("map-region-", "country_");
// 			let url = element.getAttribute("data-url").replace("--country--", id);

// 			ModalDialog.openAjax(url);
// 		});
// 	}

// 	story.MapyCz(function() {
// 		initMap();
// 		initRegions();
// 		initSignals();
// 	});
// }());
